import React, {useContext, useState} from 'react';
import {FaCode} from "react-icons/fa";
import LicensesModal from "./licenses-modal";
import {ProjectContext} from "../../../context/project-context";

const DateGenerateCellRenderer = ({value, node}) => {
    const {user} = useContext(ProjectContext);
    const [open, setOpen] = useState(false);
    const hasLicensesHistoryPermission = user?.permissions?.includes("licenses_history");

    const openLicense = () => {
        setOpen(true);
    }

    return (
        <>
            {value}

            {
                node.rowIndex === 0 && !hasLicensesHistoryPermission &&
                <>
                    <span onClick={openLicense}
                        className="w-[50px] h-full flex justify-center items-center text-white bg-blue-700 shadow border border-blue-700 cursor-pointer rounded-md ms-3">
                        <FaCode/>
                    </span>

                    <LicensesModal open={open} setOpen={setOpen} hash={node.data.hash}/>
                </>
            }
        </>
    );
};

export default DateGenerateCellRenderer;
